import { Table } from 'antd';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setIvfIdListData } from 'redux/reducers/common.slice';
import { setEmbryologyRedirect, setIvfIdRedirect } from 'redux/reducers/EmbryologyData/embryologyData.slice';
import { getPermissionLocationWise, setSelectedLocation } from 'redux/reducers/Role/role.slice';
import { setPatientEdit } from 'redux/reducers/SearchPanel/globalSearch.slice';
import { sendDataToSocket } from 'socket/SocketComponent';

const OocytesUsedTable = () => {

    const { embryologyData } = useSelector(({ embryologyData }) => embryologyData);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const columns = [
        {
          title: "Patient Name",
          dataIndex: "patient_full_name",
          key: "patient_full_name",
          render: (value) => {
            return value ?? "-";
          },
        },
        {
          title: "IVF ID",
          dataIndex: "ivf_id",
          key: "ivf_id",
          render: (value) => {
            return value ?? "-";
          },
        },
      ];

  return (
    <>
    <div className="table_heading pb-md-3 pb-2">
        <h3 className="m-0 p-0">Oocytes Used In Patient</h3>
    </div>
    <div className="cmn_table_wrap table_w_500 pb-5" >
        <Table
          columns={columns}
          dataSource={embryologyData?.embryo_used_in_patient || []}
          pagination={false}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                navigate("/");
                dispatch(setIvfIdListData([]));
                dispatch(setPatientEdit({...record, _id: record?.patient_reg_id}));
                localStorage.setItem(
                  "userLocation",
                  window.btoa(JSON.stringify(record.location_id || null))
                );
                sendDataToSocket("JUR", {
                  room_id: record.location_id || null,
                });
                dispatch(setSelectedLocation(record.location_id || null));
                dispatch(getPermissionLocationWise(record.location_id || null));
                dispatch(setEmbryologyRedirect(true));
                dispatch(setIvfIdRedirect(record.ivf_flow_id));
              },
            };
          }}
        />
  </div>
  </>
  )
}

export default memo(OocytesUsedTable)